import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import union from 'lodash/union'

import {
  earthRadiusKm,
  getDistance,
  getAngle,
  lng2tileX,
  lat2tileY,
  lightblue,
  cdblue,
} from '../lib/helpers'

import { 
  // shouldBatteriesByBoundsLoad,
  getSelectedEntity,
  getBatteries,
  getWeightBounds,
  getBatteriesNet,
  getBatteriesNetByBounds,
  getBatteriesByTiles,
  getVideos,
  getAmbassadors,
  getAwards,
} from '../selectors'

// Set this global variable so that Cesium generates requests for its
// own assets properly, with this as a prefix.
// Note that this corresponds to the static file handling in our dev server,
// and that the production output should include the Cesium build output
// in a folder by this name as well.
window.CESIUM_BASE_URL = '/cesium/'

import 'assets/cesiumWidgets.css'
import Cesium from 'cesiumDll/Cesium'
import '../lib/ImageryMixin'


import icon from '../assets/icon.png'
import iconSw from '../assets/icon-sw.png'
import iconEpark from '../assets/icon-epark.png'
import iconVideo from '../assets/icon-video-play.png'
// import boundaryLinesLand110m from '../data/ne_110m_admin_0_boundary_lines_land.json'
import boundaryLinesLand50m from '../data/ne_50m_admin_0_boundary_lines_land.json'

class CesiumWidgetClass extends Component {

  constructor(props) {
    super(props)

    this.getImageryProvider = this.getImageryProvider.bind(this)
    
    // this.drawBatteries = this.drawBatteries.bind(this)
    this.drawBatteriesPending = this.drawBatteriesPending.bind(this)
    this.updateBatteriesNet = this.updateBatteriesNet.bind(this)
    this.drawBatteriesNet = this.drawBatteriesNet.bind(this)
    this.drawBatteriesNetActive = this.drawBatteriesNetActive.bind(this)
    this.shouldUpdateBatteriesNet = this.shouldUpdateBatteriesNet.bind(this)
    this.shouldRemoveBatteriesNet = this.shouldRemoveBatteriesNet.bind(this)
    this.drawVideos = this.drawVideos.bind(this)
    this.drawAmbassadors = this.drawAmbassadors.bind(this)
    this.drawAwards = this.drawAwards.bind(this)
    this.removeBatteriesNet = this.removeBatteriesNet.bind(this)

    this.setRenderNextFrame = this.setRenderNextFrame.bind(this)
    this.animateFrame = this.animateFrame.bind(this)
    this.cameraFlyToBounds = this.cameraFlyToBounds.bind(this)
    this.cameraFlyToCenterHeight = this.cameraFlyToCenterHeight.bind(this)
    this.handleCameraFlyTo = this.handleCameraFlyTo.bind(this)
    this.loadObject = this.loadObject.bind(this)

    this.handlePreRender = this.handlePreRender.bind(this)
    
    this.handleTimeoutInit = this.handleTimeoutInit.bind(this)
    this.handleTimeoutStart = this.handleTimeoutStart.bind(this)

    this.handleCanvasClick = this.handleCanvasClick.bind(this)
    this.handleCanvasLeftDown = this.handleCanvasLeftDown.bind(this)
    this.handleCanvasLeftUp = this.handleCanvasLeftUp.bind(this)
    this.handleCanvasMouseMove = this.handleCanvasMouseMove.bind(this)
    this.handleCanvasPinchMove = this.handleCanvasPinchMove.bind(this)
    this.handleCanvasWheel = this.handleCanvasWheel.bind(this)

    this.unselectAll = this.unselectAll.bind(this)

    // helpers
    this.propagateViewport = this.propagateViewport.bind(this)
    this.getViewMagnitude = this.getViewMagnitude.bind(this)
    this.getViewHeight = this.getViewHeight.bind(this)
    this.getViewCenter = this.getViewCenter.bind(this)
    this.getViewBounds = this.getViewBounds.bind(this)

    this.state = {
      // isInializing: true,
      targetFrameRate: 24,
      renderNextFrame: 0,

      cameraIsFlying: false,
      isMouseLeftDown: false,
      isZoomingIn: 0,
      isZoomingOut: 0,
      isDragging: 0,

      height: 0,
      magnitude: 0,
      pixelSize: 1,
      bounds: null,
      center: null,

      pickedObject: null,
      // selectedObject: null,
      // selectedPosition: null,
      // selectedMagnitude: null,

      heightThreshold: 1.0e5,
    }
  }

  componentDidMount() {

    this.batteriesNetPositions = {}
    this.batteriesNetLinks = {}
    // this.batteryIds = {}
    this.batteriesAll = {}
    this.batteriesByTiles = {}
    this.batteryIdsPending = []
    this.batteryIdsAdded = []
    this.videoIds = []
    this.ambassadorIds = []
    this.awardIds = []
    // this.netPositions = []
    // this.batteriesNetParticles = []
    
    // console.log(Cesium.VERSION)

    // Cesium.Camera.DEFAULT_VIEW_RECTANGLE = Cesium.Rectangle.fromDegrees(-10,25,20,55)
    // Cesium.Camera.DEFAULT_VIEW_RECTANGLE = Cesium.Rectangle.fromDegrees(0,25,30,55) 
    Cesium.Camera.DEFAULT_VIEW_RECTANGLE = Cesium.Rectangle.fromDegrees(-118,14,-86,33 )// start intro fly from middle-america
    Cesium.Camera.DEFAULT_VIEW_FACTOR = 8

    this.viewer = new Cesium.Viewer(this.refs.cesiumNode, {
      imageryProvider: this.getImageryProvider('basemap'),
      animation: false,
      baseLayerPicker: false,
      fullscreenButton: false,
      geocoder: false,
      homeButton: false,
      infoBox: false,
      sceneModePicker: false,
      selectionIndicator: true,
      timeline: false,
      navigationHelpButton: false,
      navigationInstructionsInitiallyVisible: false,
      automaticallyTrackDataSourceClocks: false,
      // orderIndependentTranslucency: false,
      useDefaultRenderLoop: false,
      terrainShadows: 0,
      targetFrameRate: this.state.targetFrameRate,

      contextOptions: { // Scene
        contextOptions: { // WebGL creation properties
          webgl: { 
            alpha: false, 
            depth: true, 
            stencil: false, 
            antialias: false, 
            premultipliedAlpha: true, 
            preserveDrawingBuffer: false, 
            failIfMajorPerformanceCaveat: false 
          }, 
          allowTextureFilterAnisotropic: false
        }
      }
    })
    this.viewer.scene.globe.scene3DOnly = true
    this.viewer.scene.globe.enableLighting = false
    this.viewer.scene.globe.tileCacheSize = 250
    this.viewer.scene.globe.maximumScreenSpaceError = 1
    this.viewer.scene.globe.shadows = 0
    this.viewer.scene.globe.showWaterEffect = false
    this.viewer.scene.debugShowFramesPerSecond = false
    this.viewer.scene.fxaa = true
    this.viewer.scene.fxaaOrderIndependentTranslucency = false
    // this.viewer.scene.farToNearRatio = 1000 ?
    this.viewer.scene.primitives.destroyPrimitives = false

    // debugger

    // Gets or sets a scaling factor for rendering resolution. Values less than 1.0 can improve performance on less powerful 
    // devices while values greater than 1.0 will render at a higher resolution and then scale down, resulting in improved 
    // visual fidelity. For example, if the widget is laid out at a size of 640x480, setting this value to 0.5 will cause 
    // the scene to be rendered at 320x240 and then scaled up while setting it to 2.0 will cause the scene to be rendered at 
    // 1280x960 and then scaled down.
    // this.viewer.resolutionScale = .5

    // camera
    this.viewer.scene.screenSpaceCameraController.enableRotate = true
    this.viewer.scene.screenSpaceCameraController.enableTranslate = true
    this.viewer.scene.screenSpaceCameraController.enableZoom = true
    this.viewer.scene.screenSpaceCameraController.enableTilt = false
    this.viewer.scene.screenSpaceCameraController.enableLook = false
    this.viewer.scene.screenSpaceCameraController.minimumZoomDistance = 4000 // meters


    // modify SkyAtmosphere
    this.viewer.scene.skyAtmosphere.hueShift = -0.06
    this.viewer.scene.skyAtmosphere.saturationShift = 0.5
    this.viewer.scene.skyAtmosphere.brightnessShift = -0.2

    let handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas)
    handler.setInputAction(this.handleCanvasClick, Cesium.ScreenSpaceEventType.LEFT_CLICK)
    handler.setInputAction(this.handleCanvasLeftDown, Cesium.ScreenSpaceEventType.LEFT_DOWN)
    handler.setInputAction(this.handleCanvasLeftUp, Cesium.ScreenSpaceEventType.LEFT_UP)
    handler.setInputAction(this.handleCanvasMouseMove, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
    handler.setInputAction(this.handleCanvasPinchMove, Cesium.ScreenSpaceEventType.PINCH_MOVE)
    handler.setInputAction(this.handleCanvasWheel, Cesium.ScreenSpaceEventType.WHEEL)
    
    this.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)

    this.batteries = new Cesium.PointPrimitiveCollection({blendOption: Cesium.BlendOption.TRANSLUCENT})
    this.videos = new Cesium.BillboardCollection({blendOption: Cesium.BlendOption.TRANSLUCENT})
    this.ambassadors = new Cesium.PointPrimitiveCollection({blendOption: Cesium.BlendOption.TRANSLUCENT})
    this.awards = new Cesium.PointPrimitiveCollection({blendOption: Cesium.BlendOption.TRANSLUCENT})

    // this.viewer.scene.primitives.add(this.batteriesNet)
    // this.viewer.scene.primitives.add(this.batteries)

    // load-points-by-mode
    
    switch (this.props.mode) {
        case 'live' :
          this.viewer.scene.primitives.add(this.batteries)
          break
        
        case 'stories' :
          this.viewer.scene.primitives.add(this.videos)
          break
          
        case 'ambassadors' :
          this.viewer.scene.primitives.add(this.ambassadors)
          break
    }


    setTimeout(this.handleTimeoutInit, 2500)

    setTimeout(this.handleTimeoutStart, 5000)


    requestAnimationFrame(this.animateFrame)

    this.addBoundaries()
  }

  handleTimeoutInit() {

    this.loadBatteriesByBounds(
      5000,
      1, // page,
      true
    )
    this.props.loadVideosByBounds()
    this.props.loadAmbassadorsByBounds()
    // this.props.loadAwardsByBounds()
  }

  handleTimeoutStart() {
    this.viewer.scene.preRender.addEventListener(this.handlePreRender)
      
    // intro endpoint by url parameter or mode
    let urlQueryWindow = new URLSearchParams(location.search)
    // ?w=9.9&s=47.6&e=10.8&n=48
    if (    urlQueryWindow.get('w') != null 
         && urlQueryWindow.get('s') != null 
         && urlQueryWindow.get('e') != null 
         && urlQueryWindow.get('n') != null
         && urlQueryWindow.get('w') >= -180
         && urlQueryWindow.get('w') <= 180
         && urlQueryWindow.get('s') >= -90
         && urlQueryWindow.get('s') <= 90
         && urlQueryWindow.get('e') <= 180
         && urlQueryWindow.get('e') >= -180
         && urlQueryWindow.get('n') <= 90
         && urlQueryWindow.get('n') >= -90 ) {
      let paramWindow =  new Cesium.Rectangle(urlQueryWindow.get('w'),urlQueryWindow.get('s'),urlQueryWindow.get('e'),urlQueryWindow.get('n'))
      this.props.setBounds(paramWindow, 5)
    } else {
        switch (this.props.mode) {
          case 'live' :
            this.cameraFlyToCenterHeight({lat:51.2,lng:10.5}, 0.4e7, 5)
            break
        
          case 'stories' :
            this.cameraFlyToCenterHeight({lat:51.2,lng:10.5}, 1.0e7, 5)
            break
          
          case 'ambassadors' :
            this.cameraFlyToCenterHeight({lat:51.2,lng:10.5}, 0.15e7, 5)
            break
      }
    }
      
    
      
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.mode != this.props.mode) {
      
      this.unselectAll()
      this.setRenderNextFrame(true)

      switch (nextProps.mode) {
        case 'live' :
          this.viewer.scene.primitives.removeAll()
          // this.viewer.scene.primitives.add(this.batteriesNet)
          this.viewer.scene.primitives.add(this.batteries)
          let latlngLive = {
            lat: 51.2,
            lng: 10.5
          }
          this.cameraFlyToCenterHeight(latlngLive, 0.4e7, 1)

          this.boundaryLinesLand = null
          this.boundaryLinesLandType = null
          this.addBoundaries()
          break

        case 'stories' :
          this.removeBatteriesNet()

          this.boundaryLinesLand = null
          this.boundaryLinesLandType = null
          this.addBoundaries()

          this.viewer.scene.primitives.removeAll()
          this.viewer.scene.primitives.add(this.videos)
          //this.viewer.scene.primitives.add(this.ambassadors)

          // find and fly to closest video
          // const center = this.getViewCenter()
          // let closestVideo
          // let closestDistance
          // for (let key of Object.keys(this.props.videos)) {
          //   let video = this.props.videos[key]
          //   if ( ! video) {
          //     continue
          //   }
          //   let distance = getDistance(video.lng,video.lat,center.lng,center.lat)
          //   if ( ! closestVideo || distance < closestDistance) {
          //     closestVideo = video
          //     closestDistance = distance
          //     continue
          //   }
          // }
          // closestVideo.type = 'video'

          // height = Math.max(
          //   this.state.heightThreshold*8,
          //   Math.min(
          //     this.getViewHeight(), 
          //     this.state.heightThreshold*10
          //   )
          // )
          // this.cameraFlyToCenterHeight(closestVideo, 1.0e7, 1)

          // this.props.setEntityIsLoading(closestVideo.type)
          // setTimeout(this.loadObject, 1000, closestVideo)

          // this.setState({
          //   pickedObject: closestVideo,
          // })
          this.cameraFlyToCenterHeight(this.getViewCenter(), 1.0e7, 1)

          break
          
        case 'ambassadors' :
          this.removeBatteriesNet()

          this.boundaryLinesLand = null
          this.boundaryLinesLandType = null
          this.addBoundaries()

          this.viewer.scene.primitives.removeAll()
          this.viewer.scene.primitives.add(this.ambassadors)
          // let boundsDE = {
          //   west: '5.86',
          //   south: '47.27',
          //   east: '15.04',
          //   north: '55.08'
          // }
          let latlngAmbassador = {
            lat: 51.2,
            lng: 10.5
          }
          this.cameraFlyToCenterHeight(latlngAmbassador, 0.15e7, 1)
          //this.cameraFlyToBounds(boundsDE)
          //this.cameraFlyToCenterHeight([52,12], height, 1)
          break

        case 'awards' :
          this.viewer.scene.primitives.removeAll()
          this.viewer.scene.primitives.add(this.awards)

          this.boundaryLinesLand = null
          this.boundaryLinesLandType = null
          this.addBoundaries()
          break
      }
    }

    let center
    let height

    switch (true) {

      // zoom in
      case (nextProps.zoom > this.props.zoom) :
        center = this.getViewCenter()
        height = Math.max(4000, this.getViewHeight()/2)
        this.props.setCenterHeight(center, height, .5)

        // this.cameraFlyToCenterHeight(center, height, .5)
        this.unselectAll()
        // this.setRenderNextFrame(true)
        break

      // zoom out
      case (nextProps.zoom < this.props.zoom) :
        center = this.getViewCenter()
        height = Math.min(100000000, this.getViewHeight()*2)
        this.props.setCenterHeight(center, height, .5)

        // this.cameraFlyToCenterHeight(center, height, .5)
        this.unselectAll()
        // this.setRenderNextFrame(true)
        break

      // explicit center / height
      case (JSON.stringify(nextProps.targetCenter) != JSON.stringify(this.props.targetCenter)) :
      case (JSON.stringify(nextProps.targetHeight) != JSON.stringify(this.props.targetHeight)) :
        // console.log("componentWillReceiveProps.centerHeight",nextProps.targetHeight)
        height = (nextProps.targetHeight == null) 
          ? this.state.heightThreshold*2 
          : nextProps.targetHeight
        // console.log(height)
        this.cameraFlyToCenterHeight(nextProps.targetCenter, height, nextProps.targetDuration)
        break

      // explicit bounds
      case (nextProps.targetBounds && JSON.stringify(nextProps.targetBounds) !== JSON.stringify(this.props.currentBounds)) :
        // console.log("componentWillReceiveProps.bounds",nextProps)

        this.removeBatteriesNet()
        this.cameraFlyToBounds(nextProps.targetBounds, nextProps.targetDuration)
        // fixed search bug - reset target bounds
        this.props.setBounds(null)
        break

      // case (JSON.stringify(nextProps.selectedEntity) != JSON.stringify(this.props.selectedEntity)) :
      case (JSON.stringify(nextProps.currentBounds) != JSON.stringify(this.props.currentBounds)) :
        // console.log(nextProps.selectedEntity,this.shouldUpdateBatteriesNet())
        if (nextProps.selectedEntity && this.shouldUpdateBatteriesNet()) {
          let location = nextProps.selectedEntity.lat+','+nextProps.selectedEntity.lng
          this.drawBatteriesNetActive(nextProps.selectedEntity, this.batteriesNetPositions[location], true)
        }
        break

      // selected object
      // case (! this.state.cameraIsFlying && this.state.pickedObject != null && JSON.stringify(nextProps.selectedEntity) != JSON.stringify(this.props.selectedEntity)) :
      //   // console.log("componentWillReceiveProps.selectedObject")
      //   let selectedObject = nextProps.selectedEntity

      //   if (selectedObject) {
      //     this.setState({
      //       selectedObject,
      //     })

      //     if (selectedObject.video || selectedObject.ambassador) {
      //       height = this.state.heightThreshold*10
      //     } else if (this.getViewHeight() > this.state.heightThreshold) {
      //       height = this.state.heightThreshold/3
      //     } else {
      //       height = this.getViewHeight()
      //     }

      //     this.cameraFlyToCenterHeight(selectedObject, height, 1)
      //   }
      //   break
    }
      
    // fly to bounds, e.g. after search
    // if (JSON.stringify(nextProps.bounds) !== JSON.stringify(this.getViewBounds()) 
    //   && JSON.stringify(nextProps.bounds) !== JSON.stringify(this.props.bounds)) {
    //   this.cameraFlyToBounds(nextProps.bounds, 2)
    // }


    // console.log("pickedObject",this.state.pickedObject, ! this.state.cameraIsFlying,JSON.stringify(nextProps.selectedEntity) != JSON.stringify(this.props.selectedEntity))
    // if ( ! this.state.cameraIsFlying && this.state.pickedObject != null && JSON.stringify(nextProps.selectedEntity) != JSON.stringify(this.props.selectedEntity)) {

    //   let selectedObject = nextProps.selectedEntity

    //   if (selectedObject) {
    //     this.setState({
    //       selectedObject,
    //     })

    //     this.flyToSelectedObject(selectedObject)
    //   }
    // }


    // console.log(nextProps.weightBounds)
    if (nextProps.weightBounds && JSON.stringify(nextProps.weightBounds) !== JSON.stringify(this.props.weightBounds)) {
      // console.log(JSON.stringify(nextProps.weightBounds),JSON.stringify(this.props.weightBounds))
      this.loadBatteriesByBounds(5000, 1, true, nextProps.weightBounds)
    }

    if (Object.keys(nextProps.batteries).length > Object.keys(this.props.batteries).length && Object.keys(nextProps.batteriesByTiles).length > 0) {
      // this.batteriesIndex = 0

      this.batteriesAll = nextProps.batteries
      this.batteriesByTiles = nextProps.batteries

      let batteryIdsPendingNew = Object.keys(nextProps.batteries).reduce((acc, batteryId, index) => {
        if (this.batteryIdsPending.indexOf(batteryId) >= 0) {
          // console.log("delete bc pending",index)
          return acc
        }
        if (this.batteryIdsAdded.indexOf(batteryId) >= 0) {
          // console.log("delete bc added",index)
          return acc
        }
        // console.log(Object.keys(acc).length)
        acc.push(batteryId)
        return acc
      }, [])

      if (batteryIdsPendingNew.length > 0) {
      // console.log("batteryIdsPendingNew", batteryIdsPendingNew.length)
        this.batteryIdsPending = union(this.batteryIdsPending, batteryIdsPendingNew).sort()
      // console.log("this.batteryIdsPending", this.batteryIdsPending.length)
      }
      if (batteryIdsPendingNew.length === this.batteryIdsPending.length) {
        this.drawBatteriesPending(50)
      }
      // this.drawBatteries(nextProps.batteries, 25, nextProps.batteriesByTiles)
    }

    // console.log("entityIsLoading",this.props.entityIsLoading,nextProps.entityIsLoading)
    if (this.props.entityIsLoading == true && nextProps.entityIsLoading == false && nextProps.selectedEntity) {
      // this.drawBatteriesNet(nextProps.batteriesNetByBounds)

      let location = nextProps.selectedEntity.lat+','+nextProps.selectedEntity.lng
      this.drawBatteriesNetActive(nextProps.selectedEntity, this.batteriesNetPositions[location], true)
    }

    if (JSON.stringify(Object.keys(this.props.videos)) !== JSON.stringify(Object.keys(nextProps.videos))) {
      this.videosIndex = 0
      this.drawVideos(nextProps.videos)
    }

    if (JSON.stringify(Object.keys(this.props.ambassadors)) !== JSON.stringify(Object.keys(nextProps.ambassadors))) {
      this.ambassadorsIndex = 0
      this.drawAmbassadors(nextProps.ambassadors)
    }

    // if (JSON.stringify(Object.keys(this.props.awards)) !== JSON.stringify(Object.keys(nextProps.awards))) {
    //   this.awardsIndex = 0
    //   this.drawAwards(nextProps.awards)
    // }
  }

  shouldComponentUpdate() {
    return false
  }

  componentWillUnmount() {
    if(this.viewer) {
      this.viewer.destroy()
    }
  }

  // 1. pick primitive at position
  // 2. load place with primitive id
  // 3. when loaded -> center (componentWillReceiveProps)
  // 4. when centered -> display popup
  // 5. click or move camera -> unload and hide popup
  handleCanvasClick(event) {

    let pickedObject = this.viewer.scene.pick({
      x: (event.position) ? event.position.x : event.offsetX,
      y: (event.position) ? event.position.y : event.offsetY,
    })
  
    if (pickedObject && pickedObject.id) {

      let object = pickedObject.id
      let height
      // console.log(object)

      switch (object.type) {
        case 'battery' :
          height = (this.getViewHeight() > this.state.heightThreshold) 
            ? this.state.heightThreshold/3
            : this.getViewHeight()
          this.cameraFlyToCenterHeight(object, height, 1)

          // this.props.loadBattery(object.id)
          break

        case 'video' :
          height = Math.max(
            this.state.heightThreshold*8,
            Math.min(
              this.getViewHeight(), 
              this.state.heightThreshold*10
            )
          )
          this.cameraFlyToCenterHeight(object, 1.0e7, 1)

          // this.props.loadVideo(object.id)
          break

        case 'ambassador' :
          height = Math.max(
            0.15e7/20,
            Math.min(
              this.getViewHeight(), 
              0.15e7/3
            )
          )
          this.cameraFlyToCenterHeight(object, height, 1)

          // this.props.loadAmbassador(object.id)
          break

        // case 'award' :
        //   this.props.loadAward(object.id)
        //   break
      }

      this.setState({
        pickedObject: object,
      })

    } else {

      this.unselectAll()
      this.setRenderNextFrame(true)
    }
  }

  handleCanvasLeftDown(event) {
    this.setState({
      isMouseLeftDown: true,
    })
    document.getElementById('searchInputField').blur()
    if( window.innerWidth <= 560 ) {
      document.getElementById('searchInputField').style.width = '0px'
      document.getElementById('searchInputField').style.padding = '11px 0px'
      document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '3px'
      document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '3px'
      document.getElementById('clearanceButton').style.width = '0px'
      document.getElementById('clearanceButton').style.padding = '0px'  
    }
  }

  handleCanvasLeftUp(event) {
    this.setState({
      isMouseLeftDown: false,
    })
  }

  handleCanvasMouseMove(event) {
    if (this.state.cameraIsFlying) {
      return
    }
    if (this.state.isMouseLeftDown) {
      this.unselectAll()
      this.setRenderNextFrame(true)

      if (JSON.stringify(this.getViewCenter(0)) != JSON.stringify(this.state.center)) {
        this.setState({
          isDragging: 6,
        })
      }
    }
  }

  handleCanvasPinchMove(event) {
    if (this.state.cameraIsFlying) {
      return
    }

    this.unselectAll()
    this.setRenderNextFrame(true)

    if (this.getViewMagnitude(0) < this.props.currentMagnitude*1000) {
      this.setState({
        isZoomingIn: 6,
        isZoomingOut: 0,
      })
    } else if (this.getViewMagnitude(0) > this.props.currentMagnitude*1000) {
      this.setState({
        isZoomingIn: 0,
        isZoomingOut: 6,
      })
    }
    document.getElementById('searchInputField').blur()
    if( window.innerWidth <= 560 ) {
      document.getElementById('searchInputField').style.width = '0px'
      document.getElementById('searchInputField').style.padding = '11px 0px'
      document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '3px'
      document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '3px'
      document.getElementById('clearanceButton').style.width = '0px'
      document.getElementById('clearanceButton').style.padding = '0px'  
    }
  }

  handleCanvasWheel(event) {
    if (this.state.cameraIsFlying) {
      return
    }

    this.unselectAll()
    this.setRenderNextFrame(true)

    if (this.getViewMagnitude(0) < this.props.currentMagnitude*1000) {
      // console.log("zoon in",this.props.currentMagnitude*1000)
      this.setState({
        isZoomingIn: 6,
        isZoomingOut: 0,
      })
    } else if (this.getViewMagnitude(0) > this.props.currentMagnitude*1000) {
      // console.log("zoon out",this.props.currentMagnitude*1000)
      this.setState({
        isZoomingIn: 0,
        isZoomingOut: 6,
      })
    }
    document.getElementById('searchInputField').blur()
    if( window.innerWidth <= 560 ) {
      document.getElementById('searchInputField').style.width = '0px'
      document.getElementById('searchInputField').style.padding = '11px 0px'
      document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '3px'
      document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '3px'
      document.getElementById('clearanceButton').style.width = '0px'
      document.getElementById('clearanceButton').style.padding = '0px'  
    }
  }

  render() {
    return (
      <div className="CesiumWidget" ref="cesiumNode">
      </div>
    )
  }

  setRenderNextFrame(renderNextFrame) {
    if (renderNextFrame) {
      this.setState({
        renderNextFrame: this.state.targetFrameRate * 1 // 1 sec
      })
    } else if (this.state.renderNextFrame > 0) {
      this.setState({
        renderNextFrame: this.state.renderNextFrame-1
      })
    }
  }

  handlePreRender() {

    switch (true) {
      case ! this.viewer : 
      case ! this.viewer.scene : 
      case ! this.viewer.camera : 
      case ! this.batteries : 
      case this.state.cameraIsFlying : 
        return
    }

    if (this.getViewHeight() > 100000000) {
      this.cameraFlyToCenterHeight(this.getViewCenter(0), 90000000)
      return
    }
    // console.log("preRender",this.state.isDragging,this.state.isZoomingIn,this.state.isZoomingOut)

    let propagate = false
    let nextState = {}

    if (this.state.isDragging > 0) {
      nextState.center = this.getViewCenter(0)
      if (JSON.stringify(this.getViewCenter(0)) == JSON.stringify(this.state.center)) {
        nextState.isDragging = this.state.isDragging-1
        // console.log("drag",this.state.isDragging)
        if (nextState.isDragging == 0) {
          propagate = true
        }
      }
    }
    if (this.state.isZoomingIn > 0) {
      nextState.magnitude = this.getViewMagnitude(0)
      if (this.getViewMagnitude(0) == this.state.magnitude) {
        // console.log("zoomIn",this.state.isZoomingIn)
        nextState.isZoomingIn = this.state.isZoomingIn-1
        if (nextState.isZoomingIn == 0) {
          propagate = true
        }
      }
    }
    if (this.state.isZoomingOut > 0) {
      nextState.magnitude = this.getViewMagnitude(0)
      if (this.getViewMagnitude(0) == this.state.magnitude) {
        // console.log("zoomOut",this.state.isZoomingOut)
        nextState.isZoomingOut = this.state.isZoomingOut-1
        if (nextState.isZoomingOut == 0) {
          propagate = true
        }
      }
    }

    if (Object.keys(nextState).length > 0) {
      this.setState(nextState)
    }

    if (propagate) {
      this.propagateViewport()
    }

    // always point north
    let camera = this.viewer.scene.camera
    camera.setView({
      orientation: {
        heading: 0,
        pitch: camera.pitch,
        roll: camera.roll
      }
    })
  }

  unselectAll() {
    if (this.props.entityIsLoading) {
      this.props.unsetEntityIsLoading()
    }

    if (this.props.selectedEntity != null) {
      // this.props.setSelectedObject(null)
      this.props.unsetSelectedEntity()
      this.viewer.selectedEntity = null
    }

    if (this.batteriesNetActive) {
      this.viewer.scene.groundPrimitives.remove(this.batteriesNetActive)
    }
  }

  animateFrame() {

    // constant frame rate
    const self = this
    setTimeout( function() {
      requestAnimationFrame( self.animateFrame )
    }, 1000 / this.viewer.targetFrameRate )

    if (Cesium.Imagery.loadingImageryCount > 0) {
      this.setRenderNextFrame(true)
    }

    // timing for smooth animations
    // this.now = Date.now()
    // this._delta = (this.now - this._then) / 1000
    // this._then = this.now

    // // move animations
    // // let velocity = this.state.velocityEnergyStreamsRatio * this._delta // * this.getZoomRatio()*400
    // let velocity = 100 * this._delta // * this.getZoomRatio()*400

    // console.log(this.batteriesNetParticles.length)
    // for (let particle of this.batteriesNetParticles) {
    //   // let dx = (particle.sourceL-particle.targetL)
    //   // console.log(dx)
    //   // let dy = (particle.sourceL-particle.targetL)
    //   // console.log("-----")
    //   // console.log(velocity/particle.distance) //,particle.dx,particle.dy)
    //   let ratio = velocity/particle.distance

    //   particle.currentLat = particle.currentLat - particle.dx * ratio//Math.abs(particle.dx) * velocity
    //   particle.currentLng = particle.currentLng - particle.dy * ratio//Math.abs(particle.dy) * velocity

    //   let dx = particle.currentLat - particle.targetLat
    //   let dy = particle.currentLng - particle.targetLng

    //   // console.log("--")
    //   // console.log(particle.currentLat)
    //   // console.log(particle.currentLng)
    //   // console.log(dx/Math.abs(dx),particle.dx/Math.abs(particle.dx))
    //   // console.log(dy/Math.abs(dy),particle.dy/Math.abs(particle.dy))
    //   // console.log(dx/Math.abs(dx)!=particle.dx/Math.abs(particle.dx),dy/Math.abs(dy)!=particle.dy/Math.abs(particle.dy))
    //   if (dx/Math.abs(dx) != particle.dx/Math.abs(particle.dx) 
    //     && dy/Math.abs(dy) != particle.dy/Math.abs(particle.dy)) {
    //     particle = Object.assign({}, particle, {
    //       currentLng: particle.sourceLng,
    //       currentLat: particle.sourceLat,
    //     })
    //     // console.log(particle.currentVertex == particle.sourceVertex)
    //   }
    //   // console.log({x:particle.currentLat,y:particle.currentLng})
    //   // debugger
    //   // let vertex = new THREE.Vector3(
    //   //   particle.currentLat, // - this.state.frame/this.state.frameRate*dx, 
    //   //   particle.currentLng, // - this.state.frame/this.state.frameRate*dy, 
    //   //   0
    //   // )
    //   // console.log(particle.sourceLat,particle.sourceLng)
    //   // console.log(particle.sourceLat,particle.sourceLng)
    //   // console.log(vertex.lat,vertex.lng)
    //   // console.log(particle.targetLat,particle.targetLng)
    //   particle.primitive.position = Cesium.Cartesian3.fromDegrees(particle.currentLat,particle.currentLng,0)
    //   // break
    // }


    switch (true) {
      // case this.state.isInializing :
      // case this.batteriesNetParticles.length > 0 :
      case this.state.cameraIsFlying :
      case this.state.renderNextFrame > 0 :
        this.setRenderNextFrame(false)
        this.viewer.render()
        break
    }
  }

  addBoundaries(type = '50m') {
    if (type === this.boundaryLinesLandType) {
      return
    }
    // this.viewer.dataSources.add(Cesium.GeoJsonDataSource.load(boundaryLinesLand50m, {
    let boundaryLinesLand
    switch (type) {
      case '50m' :
        boundaryLinesLand = boundaryLinesLand50m
        break
      case '110m' :
      default :
        boundaryLinesLand = boundaryLinesLand110m
        break
    }

    if (this.boundaryLinesLand) {
      console.log("remove",this.boundaryLinesLandType)
      this.viewer.dataSources.remove(this.boundaryLinesLand)
    }

    Cesium.GeoJsonDataSource.load(boundaryLinesLand, {
        stroke: Cesium.Color.WHITE.withAlpha(0.3),
        fill: Cesium.Color.PINK.withAlpha(0.0),
        strokeWidth: 1
    }).then((dataSource) => {
      // Add it to the viewer
      console.log("add", type)
      this.viewer.dataSources.add(dataSource);
      // Remember the data source by ID so we can delete later
      this.boundaryLinesLand = dataSource;
      this.boundaryLinesLandType = type;
    })
  }

  shouldUpdateBatteriesNet() {

    // console.log(this.batteryIdsPending.length)
    if (this.weightBounds) {
      return false
    }

    if (this.batteryIdsPending.length > 0) {
      return false
    }

    if (this.props.mode != 'live') {
      return false
    }

    let bounds = this.getViewBounds()
    let deltaLat = (bounds) ? bounds.east-bounds.west : 10
    let deltaLng = (bounds) ? bounds.north-bounds.south : 10
    let magnitude = this.getViewMagnitude()

    switch (true) {
      case deltaLat > 1.5 :
      case deltaLng > 1.5 : // && deltaCurrentLat > 1.5 && deltaCurrentLng > 1.5 :
      case magnitude-earthRadiusKm > 75 : // && this.props.currentMagnitude-earthRadiusKm > 75 :
        return false
    }
    return true
  }

  shouldRemoveBatteriesNet() {
    // console.log(this.viewer.scene.groundPrimitives.length)
    if (this.viewer.scene.groundPrimitives.length == 0) {
      return false
    }

    if (this.props.mode != 'live') {
      return true
    }

    let deltaCurrentLat = this.props.currentBounds.east-this.props.currentBounds.west
    let deltaCurrentLng = this.props.currentBounds.north-this.props.currentBounds.south

    let bounds = this.getViewBounds()
    let deltaLat = (bounds) ? bounds.east-bounds.west : 10
    let deltaLng = (bounds) ? bounds.north-bounds.south : 10

    // console.log(deltaLat, deltaCurrentLat)
    // console.log(deltaLng, deltaCurrentLng)
    // console.log(this.getViewMagnitude()-earthRadiusKm, this.props.currentMagnitude-earthRadiusKm)
    switch (true) {
      case deltaLat > 1.5 && deltaCurrentLat <= 1.5 :
      case deltaLng > 1.5 && deltaCurrentLng <= 1.5 :
      case this.getViewMagnitude()-earthRadiusKm > 75 : // && this.props.currentMagnitude-earthRadiusKm <= 75 :
        return true
    }
    return false
  }

  // deprectaced method + signatute
  // drawBatteries(batteries, n = 25, batteriesByTiles = {}) {
  //   if ( ! batteries) {
  //     return
  //   }

  //   let keys = Object.keys(batteries)
  //   // console.log("drawBatteries:",keys.length)
  //   if (keys.length <= this.batteriesIndex) {
  //     return
  //   }
  //   // console.log(keys)
  //   let max = n+this.batteriesIndex
  //   // console.log("drawBatteries",n,this.batteriesIndex,max)
    
  //   for (let i=this.batteriesIndex; i<max; i++) {
      
  //     if (batteries.length <= this.batteriesIndex) {
  //       return
  //     }

  //     let battery = batteries[keys[i]]

  //     if ( ! battery) {
  //       // console.log("skip")
  //       // console.log("skip1",battery)
  //       this.batteriesIndex++
  //       continue
  //     }
      
  //     if (this.batteryIds[battery.id] === true) {
  //       // console.log("skip2",battery.id)
  //       this.batteriesIndex++
  //       continue
  //     }

  //     this.batteryIds[battery.id] = true
      
  //     let pixelSize = this.state.pixelSize

  //     let key
  //     let len

  //     if (battery.lng != undefined && battery.lat != undefined) {

  //       key = '_'+lng2tileX(battery.lng)+'_'+lat2tileY(battery.lat)
  //       // console.log(key)
  //       if (batteriesByTiles[key]) {
  //         // console.log(batteriesByTiles[key].batteries.length)
  //         len = batteriesByTiles[key].batteries.length
  //         pixelSize = this.state.pixelSize * 1/(len/(len+2))
  //       }

  //       // console.log(key)

  //       this.batteries.add({
  //         position: Cesium.Cartesian3.fromDegrees(battery.lng, battery.lat, 0),
  //         pixelSize: pixelSize, // * Math.min(5, ((battery.weight || 1)+6)/7),
  //         color: lightblue.fill,
  //         outlineColor: cdblue.outline,
  //         outlineWidth: 0.5,
  //         // color: new Cesium.Color(255/255,0/255,0/255,1.0),
  //         id: Object.assign({}, battery, {type: 'battery'}),
  //         scaleByDistance: new Cesium.NearFarScalar(1.0e1, 7.0, 0.6e6, 1.2),
  //         // scaleByDistance: new Cesium.NearFarScalar(1e5, 3.0, 3e6, 1.2),
  //         // translucencyByDistance: new Cesium.NearFarScalar(0.75e5, 0.0, 1.25e5, 1.0),
  //       })
  //       // console.log(this.allBatteries._pointPrimitives.length)

  //       this.batteriesIndex++
  //     }
  //   }

  //   if (n == 25) {
  //     setTimeout(this.drawBatteries, 1, batteries, n, batteriesByTiles)
  //   }
  // }


  drawBatteriesPending(n = 25) {

    let max = n
    while (max-- > 0 && this.batteryIdsPending.length > 0) {

      let batteryId = this.batteryIdsPending.shift()
      if (this.batteryIdsAdded.indexOf(batteryId) >= 0) {
        continue
      }

      let battery = this.batteriesAll[batteryId]
      if ( ! battery) {
        continue
      }

      let pixelSize = this.state.pixelSize

      let key
      let len

      if (battery.lng != undefined && battery.lat != undefined) {

        key = '_'+lng2tileX(battery.lng)+'_'+lat2tileY(battery.lat)
        // console.log(key)
        if (this.batteriesByTiles[key]) {
          // console.log(this.batteriesByTiles[key].batteries.length)
          len = this.batteriesByTiles[key].batteries.length
          pixelSize = this.state.pixelSize * 1/(len/(len+2))
        }

        this.batteries.add({
          position: Cesium.Cartesian3.fromDegrees(battery.lng, battery.lat, 0),
          pixelSize: pixelSize,
          color: lightblue.fill,
          outlineColor: cdblue.outline,
          outlineWidth: 0.5,
          // color: new Cesium.Color(255/255,0/255,0/255,1.0),
          id: Object.assign({}, battery, {type: 'battery'}),
          scaleByDistance: new Cesium.NearFarScalar(1.0e1, 7.0, 0.6e6, 1.2),
          // scaleByDistance: new Cesium.NearFarScalar(1e5, 3.0, 3e6, 1.2),
          // translucencyByDistance: new Cesium.NearFarScalar(0.75e5, 0.0, 1.25e5, 1.0),
        })

        this.batteryIdsAdded.push(batteryId)
      }
    }

    // console.log(this.batteryIdsPending.length+this.batteryIdsAdded.length,this.batteryIdsPending.length,this.batteryIdsAdded.length)
    if (this.batteryIdsPending.length > 0) {
      setTimeout(this.drawBatteriesPending, 1, n)
      this.setRenderNextFrame(true)
    } else {
      this.updateBatteriesNet(true)
    }
  }

  drawBatteriesNet(links) {

    // console.log("drawBatteriesNet",this.props.weightBounds)

    // if ( ! this.shouldUpdateBatteriesNet()) {
      // this.removeBatteriesNet()
      // return
    // }

    // if ( ! this.groundPrimitives) {
    //   this.groundPrimitives = []
    // }

    let geometryInstances = []
    let maxDistance = 100
    for (let i = 0; i < links.length; i++) {

      let link = links[i]
      let linkString = JSON.stringify(link)
      // console.log(link,this.batteriesNetLinks[linkString])
      if (this.batteriesNetLinks[linkString] === true) {//.indexOf(JSON.stringify(link)) >= 0) {
        continue
      }

      let sourceKey = link.source[0]+','+link.source[1]
      if (this.batteriesNetPositions[sourceKey] === undefined) {
        this.batteriesNetPositions[sourceKey] = []
      }
      let targetKey = link.target[0]+','+link.target[1]
      if (this.batteriesNetPositions[targetKey] === undefined) {
        this.batteriesNetPositions[targetKey] = []
      }
      
      this.batteriesNetPositions[sourceKey].push(link.target)
      this.batteriesNetPositions[targetKey].push(link.source)
      this.batteriesNetLinks[linkString] = true // .push(JSON.stringify(link))




      let linkPositions = [
        link.source[1], link.source[0],
        link.target[1], link.target[0]
      ]

      let positions = Cesium.Cartesian3.fromDegreesArray(linkPositions)

      geometryInstances.push(new Cesium.GeometryInstance({
        geometry: new Cesium.CorridorGeometry({
          positions,
          width: 70,
        }),
        attributes: {
          color: new Cesium.ColorGeometryInstanceAttribute(1.0, 1.0, 1.0, 0.5)
        },
      }))
    }

    // console.log("lines",geometryInstances.length)
    if (geometryInstances.length > 0) {

      // this.removeBatteriesNet()

      let groundPrimitive = new Cesium.GroundPrimitive({
        geometryInstances,
        allowPicking: false, 
        show: true,
        releaseGeometryInstances: false,
      })

      this.viewer.scene.groundPrimitives.add(groundPrimitive)

      // this.groundPrimitives.push(groundPrimitive)

      // console.log(this.groundPrimitives.length)
      // if (this.groundPrimitives.length > 1) {
      //   setTimeout(function() {
      //     groundPrimitive = this.groundPrimitives.shift()
      //     this.viewer.scene.groundPrimitives.remove(groundPrimitive)
      //     if (groundPrimitive && ! groundPrimitive.isDestroyed) {
      //       groundPrimitive.destroy()
      //     }
      //   }.bind(this),250)
      // }
    }

    // console.log('drawBatteriesNet', this.viewer.scene.groundPrimitives.length)

    if (this.props.entityIsLoading && this.props.selectedEntity) {
      let location = this.props.selectedEntity.lat+','+this.props.selectedEntity.lng
      this.drawBatteriesNetActive(this.props.selectedEntity, this.batteriesNetPositions[location], true)
    }
  }

  drawBatteriesNetActive(object, leafs = [], forceUpdate = false) {
    
    // if (this.props.selectedObject && ! forceUpdate) {
    //   return
    // }
    // console.log('drawBatteriesNetActive',object,leafs)
    if (this.batteriesNetActive) {
      this.viewer.scene.groundPrimitives.remove(this.batteriesNetActive)
    }

    if (object) {

      // this.batteriesNetStreams = new Cesium.PointPrimitiveCollection()

      let geometryInstances = []
      for (let i = 0; i < leafs.length; i++) {

        let leaf = leafs[i]

        let leafPositions = [
          object.lng, object.lat,
          leaf[1], leaf[0]
        ]

        let positions = Cesium.Cartesian3.fromDegreesArray(leafPositions)

        geometryInstances.push(new Cesium.GeometryInstance({
          geometry: new Cesium.CorridorGeometry({
            positions,
            width: 75,
          }),
          attributes: {
            color: new Cesium.ColorGeometryInstanceAttribute(76/255,207/255,239/255, 1.0)
          },
        }))


        // let currentLng = object.lng + (leaf[1]-object.lng)
        // let currentLat = object.lat + (leaf[0]-object.lat)

        // let primitive = this.batteriesNetStreams.add({
        //   position: Cesium.Cartesian3.fromDegrees(currentLng, currentLat, 0),
        //   pixelSize: 20,
        //   color: new Cesium.Color(255/255,255/255,255/255,0.75),
        // })

        // const distance = getDistance(object.lng, object.lat, leaf[1], leaf[0])
        // this.batteriesNetParticles.push({
        //   primitive,
        //   currentLng,
        //   currentLat,
        //   sourceLng: object.lng,
        //   sourceLat: object.lat,
        //   targetLng: leaf[1],
        //   targetLat: leaf[0],
        //   deltaLng: (leaf[1]-object.lng), 
        //   deltaLat: (leaf[0]-object.lat),
        //   distance
        // })
      }

      // console.log(geometryInstances)
      if (geometryInstances.length > 0) {
        this.batteriesNetActive = new Cesium.GroundPrimitive({
          geometryInstances,
          allowPicking: false, 
          show: true,
        })
        this.viewer.scene.groundPrimitives.add(this.batteriesNetActive)
      }

      // this.viewer.scene.primitives.add(this.batteriesNetStreams)
    }

    this.setRenderNextFrame(true)
  }

  removeBatteriesNet() { // keepLatest = false) {

    // console.log("removeBatteriesNet")
    let len = this.viewer.scene.groundPrimitives.length
    // console.log("removeBatteriesNet",len)
    // if (keepLatest) {
    //   len--
    // }
    for (let i = 0; i < len; i++) {
      // console.log("remove",i)
      let geometry = this.viewer.scene.groundPrimitives.get(i)
      this.viewer.scene.groundPrimitives.remove(geometry)
      if (geometry && ! geometry.isDestroyed) {
        geometry.destroy()
      }
    }

    this.batteriesNetLinks = {}
    this.batteriesNetPositions = {}
    this.batteriesNetActive = null
    // this.batteriesNetParticles = []
  }

  drawVideos(videos) {
    for (let key of Object.keys(videos)) {
      
      let video = videos[key]
      if ( ! video || this.videoIds.indexOf(video.id) >= 0) {
        continue
      }
      this.videoIds.push(video.id)

      // this.videos.add({
      //   position: Cesium.Cartesian3.fromDegrees(video.lng, video.lat, 0),
      //   pixelSize: 30,
      //   color: new Cesium.Color(215/255,238/255,251/255,1.0),
      //   outlineColor: new Cesium.Color(215/255,238/255,251/255,0.15),
      //   outlineWidth: 0.5,
      //   id: Object.assign({}, video, {type: 'video'}),
      // })

      this.videos.add({
        position : Cesium.Cartesian3.fromDegrees(video.lng, video.lat, 0),
        image : iconVideo,
        id: Object.assign({}, video, {type: 'video'}),
        width: 40,
        height: 40,
      })
    }
  }

  drawAmbassadors(ambassadors) {
    for (let key of Object.keys(ambassadors)) {

      let ambassador = ambassadors[key]
      if ( ! ambassador || this.ambassadorIds.indexOf(ambassador.id) >= 0) {
        continue
      }
      this.ambassadorIds.push(ambassador.id)

      this.ambassadors.add({
        position: Cesium.Cartesian3.fromDegrees(ambassador.lng, ambassador.lat, 0),
        pixelSize: 8,
        color: new Cesium.Color(215/255,238/255,251/255,1.0),
        outlineColor: new Cesium.Color(76/255,207/255,239/255,0.15),
        outlineWidth: 2,
        id: Object.assign({}, ambassador, {type: 'ambassador'}),
        scaleByDistance: new Cesium.NearFarScalar(1.8e6, 1.0, 1.8e7, 0.3),
      })
    }
  }

  drawAwards(awards) {
    for (let key of Object.keys(awards)) {

      let award = awards[key]
      if ( ! award || this.awardIds.indexOf(award.id) >= 0) {
        continue
      }
      this.awardIds.push(award.id)

      this.awards.add({
        position: Cesium.Cartesian3.fromDegrees(award.lng, award.lat, 0),
        pixelSize: 15,
        color: new Cesium.Color(215/255,238/255,251/255,1.0),
        outlineColor: new Cesium.Color(215/255,238/255,251/255,0.15),
        outlineWidth: 0.5,
        id: Object.assign({}, award, {type: 'award'}),
      })
    }
  }

  cameraFlyToCenterHeight(center, height = null, duration = 1, complete = this.handleCameraFlyTo) {
    // console.log("cameraFlyToCenterHeight",{center,height})
    if ( ! this.state.cameraIsFlying) {
    
      this.setState({
        cameraIsFlying: true,
      })
      this.props.setCameraIsFlying(true)

      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          center.lng, 
          center.lat, 
          height
        ),
        duration,
        easingFunction: Cesium.EasingFunction.QUADRACTIC_IN_OUT,
        complete,
      })
    }
  }

  cameraFlyToBounds(bounds, duration = 1, complete = this.handleCameraFlyTo) {
    // console.log("cameraFlyToBounds",{bounds})
    if ( ! this.state.cameraIsFlying) {
    
      this.setState({
        cameraIsFlying: true,
      })
      this.props.setCameraIsFlying(true)

      this.viewer.camera.flyTo({
        destination: Cesium.Rectangle.fromDegrees(
          bounds.west,
          bounds.south,
          bounds.east,
          bounds.north
        ),
        duration,
        easingFunction: Cesium.EasingFunction.QUADRACTIC_IN_OUT,
        complete,
      })
    }
  }

  handleCameraFlyTo() {
    // console.log('handleCameraFlyTo')

    this.propagateViewport()

    // if (this.props.selectedEntity) {

    //   if (this.props.mode == 'live') {
    //     let location = this.props.selectedEntity.lat+','+this.props.selectedEntity.lng
    //     this.drawBatteriesNetActive(this.props.selectedEntity, this.batteriesNetPositions[location], true)
    //   }

    //   this.props.setSelectedObject(this.props.selectedEntity)
    //   this.props.setSelectedEntity(null)
    //   this.setState({
    //     pickedObject: null,
    //     cameraIsFlying: false,
    //     selectedObject: null,
    //     // selectedPosition: this.getViewCenter(),
    //     // selectedMagnitude: this.getViewMagnitude(),
    //   })
    // } else {
      this.setState({
        cameraIsFlying: false,
      })
      this.props.setCameraIsFlying(false)
    // }

    if (this.state.pickedObject) {
      this.props.setEntityIsLoading(this.state.pickedObject.type)
      setTimeout(this.loadObject, 500, this.state.pickedObject)
    }
  }

  loadObject(object) {
    switch (object.type) {
      case 'battery' :
        this.props.loadBattery(object.id)
        break

      case 'video' :
        this.props.loadVideo(object.id)
        break

      case 'ambassador' :
        this.props.loadAmbassador(object.id)
        break
    }
    this.setState({
      pickedObject: null,
    })
  }

  // 1. load world -> places have weight
  // 2. on zoom out no place loading
  // 3. on zoom in check max weight in bounds
  // 4. on move check max weight in bounds
  // - if max weight == 1 no places loading
  // - if max weight > 1 load places for bounds
  // - set height thresholds
  // always round bounds (depending on height)

  // load helper
  loadBatteriesByBounds(limit = 5000, page = 1, forceLoad = false, forceBounds = null) {

    let bounds = (forceBounds)
      ? forceBounds
      : this.getViewBounds()
    // console.log({bounds})

    if (bounds.south <= -90 && bounds.north >= 90 && bounds.west <= -180 && bounds.east >= 180) {
      if ( ! forceLoad && this.globeLoaded) {
        return
      }
      this.globeLoaded = true
    }

    if (forceLoad) {
      // console.log("LOAD force",bounds)
      this.props.loadBatteriesByBounds(
        bounds.south.toFixed(2), 
        bounds.west.toFixed(2), 
        bounds.north.toFixed(2), 
        bounds.east.toFixed(2), 
        limit,
        page
      )
      return
    }
  }


  // propagate viewport values to props + selectors
  propagateViewport() {
    // console.log('propagateViewport',this.getViewBounds())
    // this.addBoundaries(this.getViewMagnitude() <= 7500 ? '50m' : '110m')
    this.props.setViewport(
      this.getViewBounds(),
      this.getViewCenter(),
      this.getViewHeight(),
      this.getViewMagnitude()
    )
    
    // console.log("propagateViewport",this.shouldUpdateBatteriesNet(),this.shouldRemoveBatteriesNet())
    this.updateBatteriesNet()
  }

  updateBatteriesNet(forceRedraw = false) {
    if (this.shouldUpdateBatteriesNet()) {
      
      this.setState({
        center: this.getViewCenter(0),
        height: this.getViewHeight(0),
        magnitude: this.getViewMagnitude(0),
      })

      // console.log("propagateViewport")
      if (forceRedraw) {
        this.removeBatteriesNet()
      }
      this.drawBatteriesNet(this.props.batteriesNetByBounds)

    } else if (this.shouldRemoveBatteriesNet()) {

      this.removeBatteriesNet()
    }
  }

  // magnitude helper
  getViewMagnitude(round = 1000) {
    // distance to globe center
    if (round > 0) {
      return Math.round(this.viewer.camera.getMagnitude()/round)
    } else {
      return this.viewer.camera.getMagnitude()
    }
  }

  // height helper
  getViewHeight(round = 1) {
    // height from surface
    if (round > 0) {
      return Math.round(this.viewer.camera.positionCartographic.height)
    } else {
      return this.viewer.camera.positionCartographic.height
    }
  }

  // center helper
  getViewCenter(round = 10) {
    switch (true) {
      case ! this.viewer :
      case ! this.viewer.camera :
      case ! this.viewer.scene :
      case ! this.viewer.scene.globe :
      case ! this.viewer.scene.globe.ellipsoid :
      case ! this.viewer.container.clientWidth :
      case ! this.viewer.container.clientHeight :
        return { lng: 0, lat: 0 }
    }
    const windowPosition = new Cesium.Cartesian2(this.viewer.container.clientWidth / 2, this.viewer.container.clientHeight / 2)
    const pickRay = this.viewer.camera.getPickRay(windowPosition)
    const pickPosition = this.viewer.scene.globe.pick(pickRay, this.viewer.scene)
    if ( ! pickPosition) {
        return { lng: 0, lat: 0 }
    }
    const pickPositionCartographic = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(pickPosition)
    
    if (round > 0) {
      return {
        lng: Math.round(pickPositionCartographic.longitude*(180/Math.PI)*round)/round,
        lat: Math.round(pickPositionCartographic.latitude*(180/Math.PI)*round)/round,
      }
    } else {
      return {
        lng: pickPositionCartographic.longitude*(180/Math.PI),
        lat: pickPositionCartographic.latitude*(180/Math.PI),
      }
    }
  }

  // bounds helper
  getViewBounds() {
    switch (true) {
      case ! this.viewer :
      case ! this.viewer.scene :
      case ! this.viewer.camera :
        return { west: -180, south: -90, east: 180, north: 90 }
    }

    let rect = this.viewer.camera.computeViewRectangle()
    let bounds = {}
    // let padding = .1

    bounds.west = Math.floor(Cesium.Math.toDegrees(rect.west)*10)/10
    bounds.south = Math.floor(Cesium.Math.toDegrees(rect.south)*10)/10
    bounds.east = Math.ceil(Cesium.Math.toDegrees(rect.east)*10)/10
    bounds.north = Math.ceil(Cesium.Math.toDegrees(rect.north)*10)/10

    // console.log(bounds.west+bounds.east,bounds.south+bounds.north)

    return bounds
  }

  // image provider helper
  getImageryProvider(type) {

    let imageryProvider

    switch (type) {
      case 'mapbox' :
        let MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoibmJhdSIsImEiOiJjajFjNmtmcmQwMDhtMndydWZoNndlNjZmIn0.7rc2bp0qsTwbeQ2vL1oZqw'
        let MAPBOX_STYLE_ID = 'cj1eskg5p00i82rqszyr2ejrp' // 'cj06tsqdu00he2rmvkjysgfvw' // 'satellite-v9'
        let MAPBOX_USERNAME = 'nbau' // 'mapbox'
        let MAPBOX_TILE_SIZE = '512' // '256' or '512'

        // defaults
        // mapbox://styles/mapbox/streets-v9
        // mapbox://styles/mapbox/outdoors-v9
        // mapbox://styles/mapbox/light-v9
        // mapbox://styles/mapbox/dark-v9
        // mapbox://styles/mapbox/satellite-v9
        // mapbox://styles/mapbox/satellite-streets-v9

        let mapboxUrl = 'https://api.mapbox.com/styles/v1/'+MAPBOX_USERNAME+'/'+MAPBOX_STYLE_ID+'/tiles/'+MAPBOX_TILE_SIZE+'/{z}/{x}/{y}?access_token='+MAPBOX_ACCESS_TOKEN
        imageryProvider = new Cesium.UrlTemplateImageryProvider({
          url: mapboxUrl,
          tileWidth: MAPBOX_TILE_SIZE,
          tileHeight: MAPBOX_TILE_SIZE,
          enablePickFeatures: false,
        })
        break

      case 'bing' :
        imageryProvider = new Cesium.BingMapsImageryProvider({
          url: 'https://dev.virtualearth.net',
          key: 'AnNNVBbVn4tyPlGfi-oruHoZi1Mffv3HXel_t78xjF8bBW837HXiuAgnHXGKmVpO',
          mapStyle: Cesium.BingMapsStyle.ROAD
        })
        break

      case 'osm' :
        imageryProvider = new Cesium.createOpenStreetMapImageryProvider({
          url: 'https://a.tile.openstreetmap.org/'
        })
        break

      case 'arcgis' :
        imageryProvider = new Cesium.WebMapServiceImageryProvider({
          url: 'https://sampleserver1.arcgisonline.com/ArcGIS/services/Specialty/ESRI_StatesCitiesRivers_USA/MapServer/WMSServer',
          layers: '0',
          proxy: new Cesium.DefaultProxy('/proxy/')
        })
        break

      case 'basemap' :
      default :
        imageryProvider = new Cesium.ArcGisMapServerImageryProvider({
          url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
          tileWidth: 256,
          tileHeight: 256,
          enablePickFeatures: false,
          usePreCachedTilesIfAvailable: true
        })
        break
    }
    return imageryProvider
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    selectedEntity: getSelectedEntity(state),
    batteriesNetByBounds: getBatteriesNetByBounds(state),
    batteriesByTiles: getBatteriesByTiles(state),
    weightBounds: getWeightBounds(state),

    batteries: getBatteries(state),
    videos: getVideos(state),
    ambassadors: getAmbassadors(state),
    // awards: getAwards(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

const CesiumWidget = connect(
  mapStateToProps,
  mapDispatchToProps
)(CesiumWidgetClass)

export default CesiumWidget





// WEBPACK FOOTER //
// ./src/components/CesiumWidget.js